import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Badge,
  Button,
  Container,
  Grid,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead'
import Divider from '@mui/material/Divider'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import LockResetIcon from '@mui/icons-material/LockReset'
import RedeemIcon from '@mui/icons-material/Redeem'
import AppIcon from './AppIcon'
import { showToast } from '../utils/AppHelper'
import { TextBold, TextHover, TextRegular, TextSemiBold } from './TextStyling'
import { logoutUser } from '../actions/loginActions'
import { useDispatch } from 'react-redux'
import appassets from '../utils/appassets'
import { paddingHorizontal } from '../utils/AppConstants'
import NotificationsIcon from './NotificationsIcon'
import QuizIcon from '@mui/icons-material/Quiz'
import { ENV } from '../ENV'

export default function HeaderRecruiter({ user }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  const [openMenu, setOpenMenu] = useState(false)
  const [passwordModal, setPasswordModal] = useState({ open: false })
  const [walkthroughActive, setWalkthroughActive] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  const [highlightPosition, setHighlightPosition] = useState({})
  const [tooltipPosition, setTooltipPosition] = useState({})
  const walkthroughRefs = useRef({})
  const handleJobsOpen = e => setAnchorJobs(e.currentTarget)
  const handleJobsClose = () => setAnchorJobs(null)
  const [anchorJobs, setAnchorJobs] = useState(null)
  const handleMouseLeave = () => {
    setOpenMenu(false)
  }

  const [headerItems, setHeaderItems] = useState([
    {
      label: 'Summary board',
      nav: '/recruiter/dashboard'
    },
    {
      label: 'Monitor candidate',
      nav: '/recruiter/trackcandidate'
    },
    {
      label: 'Jobs',
      menuId: 1,
      open: false,
      menu: [
        {
          label: 'Search Jobs',
          nav: '/recruiter/newsearch'
        },
        { label: 'Active Jobs', nav: '/recruiter/worklist' },
        { label: 'Past Assigment', nav: '/recruiter/workedon' }
      ]
    },
    {
      label: 'Referral income',
      nav: '/recruiter/referralearning'
    }
  ])
  const walkthroughSteps = [
    {
      target: 'summary-board',
      title: 'Summary Board',
      description: 'Your main dashboard with key metrics and performance overview.'
    },
    {
      target: 'monitor-candidate',
      title: 'Monitor Candidate',
      description: 'Track candidate progress amd application status here.'
    },
    {
      target: 'jobs',
      title: 'Jobs Menu',
      description: 'Click to see available job opportunities and options.'
    },
    {
      target: 'referral-income',
      title: 'Referral Income',
      description: 'View your referral earnings and commission details.'
    },
    {
      target: 'account-menu',
      title: 'Edit Profile',
      description: 'Click here to manage your account details and preferences.',
      expandAccountMenu: true
    }

  ]
  const completeWalkthrough = () => {
    setWalkthroughActive(false)
    setCurrentStep(0)
    if (user?.id) {
      localStorage.setItem(`walkthrough_seen_${user.id}`, 'true')
    }
  }


  const skipWalkthrough = () => {
    completeWalkthrough()
  }
  const setWalkthroughRef = (key) => (el) => {
    if (el) walkthroughRefs.current[key] = el
  }
  useEffect(() => {
    if (walkthroughActive && walkthroughSteps[currentStep]) {
      const step = walkthroughSteps[currentStep]
      const el = walkthroughRefs.current[step.target]

      if (el) {
        const rect = el.getBoundingClientRect()
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })

        setHighlightPosition({
          top: rect.top + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
          height: rect.height
        })

        setTooltipPosition({
          top: rect.bottom + window.scrollY + 10,
          left: rect.left + window.scrollX
        })

        if (step.target === 'account-menu') {
          setTooltipPosition({
            top: '80px',
            left: '70%',
            transform: 'translateX(-50%)'
          })
        }
        if (step?.target === 'account-menu') {
          setOpenMenu(true);
        }

      }
    }
  }, [walkthroughActive, currentStep])
  // useEffect(() => {

  //   setWalkthroughActive(true);
  // }, []);
  useEffect(() => {

    const walkthroughShownThisSession = sessionStorage.getItem('walkthrough_shown');
    const hasSeenWalkthrough = localStorage.getItem('recruiter_walkthrough_completed');

    if (!hasSeenWalkthrough && !walkthroughShownThisSession) {
      setWalkthroughActive(true);

      sessionStorage.setItem('walkthrough_shown', 'true');
    }
  }, []);

  const handleWalkthroughComplete = () => {
    setWalkthroughActive(false);
    localStorage.setItem('recruiter_walkthrough_completed', 'true');
  };
  return (
    <AppBar
      sx={{
        bgcolor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.border.main}`
      }}
      elevation={0}
    >
      <Toolbar
        style={{
          height: matches ? '4rem' : '60px',
          paddingLeft: matches ? '16px' : paddingHorizontal,
          paddingRight: matches ? '16px' : paddingHorizontal
        }}
      >
        <div onClick={() => navigate('/recruiter/dashboard')} style={{ flexGrow: 1 }}>
          <AppIcon style={{ width: matches ? '80px' : 80, cursor: 'pointer' }} />
        </div>

        <div style={{ display: 'flex' }}>
          {!matches && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                flexGrow: 1,
                marginRight: 16
              }}
            >
              {headerItems.map((item, index) => {
                const targetKey = item.label.toLowerCase().replace(/\s/g, '-') // "Summary board" - "summary-board"

                return (
                  <div key={index} ref={setWalkthroughRef(targetKey)}>
                    {item.menu ? (
                      <>
                        <Button
                          id={item.menuId}
                          style={{
                            padding: '10px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            textTransform: 'capitalize'
                          }}
                          onClick={() => {
                            const items = [...headerItems]
                            items[index].open = true
                            setHeaderItems(items)
                          }}
                          aria-controls={item.open ? item.menuId : undefined}
                          aria-haspopup='true'
                          aria-expanded={item.open ? true : undefined}
                        >
                          <TextSemiBold style={{ fontSize: '15px' }}>
                            <TextHover style={{ display: 'flex' }}>
                              {item.label}
                              <KeyboardArrowDownIcon />
                            </TextHover>
                          </TextSemiBold>
                        </Button>

                        {/* Menu rendering here */}
                        <Menu
                          id={item.menuId}
                          anchorE2={item.anchor}
                          open={item.open}
                          onClose={() => {
                            const items = [...headerItems]
                            items[index].open = false
                            setHeaderItems(items)
                          }}
                          anchorPosition={{
                            vertical: 'top',
                            horizontal: 'center'
                          }}
                          anchorEl={document.getElementById(item.menuId)}
                          slotProps={{
                            paper: {
                              elevation: 0,
                              sx: {
                                overflow: 'hidden',
                                filter:
                                  'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
                                mt: 7.5,
                                borderRadius: '0px',
                                top: '5px !important',
                                '& .MuiAvatar-root': {
                                  width: 32,
                                  height: 32,
                                  ml: -0.5,
                                  mr: 1
                                },
                                '&::before': {
                                  content: '""',
                                  display: 'block',
                                  position: 'absolute',
                                  top: 0,
                                  right: 14,
                                  width: 10,
                                  height: 10,
                                  transform: 'translateY(-50%) rotate(45deg)',
                                  zIndex: 0
                                }
                              }
                            }
                          }}
                        >
                          {item?.menu?.map((item, i) => (
                            <>
                              {i === 0 && (
                                <Box
                                  style={{
                                    width: '100%',
                                    height: '4px',
                                    background: theme.palette.primary.main,
                                    padding: '0px',
                                    marginTop: '-8px'
                                  }}
                                />
                              )}
                              <MenuItem
                                style={{
                                  fontSize: 14,
                                  fontWeight: 500,
                                  lineHeight: '2rem'
                                }}
                                onClick={() => {
                                  const items = [...headerItems]
                                  items[index].open = false
                                  setHeaderItems(items)
                                  if (item.nav) {
                                    navigate(item.nav)
                                  }
                                }}
                              >
                                <TextHover>{item.label}</TextHover>
                              </MenuItem>
                            </>
                          ))}
                        </Menu>
                      </>
                    ) : (
                      <TextSemiBold
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          fontSize: '15px'
                        }}
                        onClick={() => navigate(item.nav)}
                      >
                        <TextHover>{item.label}</TextHover>
                      </TextSemiBold>
                    )}
                  </div>
                )
              })}
            </div>
          )}
          {walkthroughActive && (
            <>
              {/* Overlay */}
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: 2000
                }}
              />

              {/* Highlight Box */}
              <div
                style={{
                  position: 'absolute',
                  top: highlightPosition.top - 2,    
                  left: highlightPosition.left - 4,    
                  width: highlightPosition.width + 8,  
                  height: highlightPosition.height + 8, 
                  border: '2px solid #3b82f6',
                  borderRadius: '6px',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
                  zIndex: 2001
                }}
              />

              {/* Tooltip */}
              <div
                style={{
                  position: 'absolute',
                  top: tooltipPosition.top,
                  left: tooltipPosition.left,
                  width: '250px',
                  // backgroundColor: 'white',
                  padding: '16px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
                  zIndex: 2002
                }}

              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <h4 style={{ margin: '0 0 8px' }}>{walkthroughSteps[currentStep].title}</h4>
                  <button
                    onClick={skipWalkthrough}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '18px',
                      cursor: 'pointer',
                      color: 'white'
                    }}
                  >
                    ×
                  </button>
                </div>

                <p style={{ margin: 0 }}>{walkthroughSteps[currentStep].description}</p>
                <div style={{ marginTop: 12, textAlign: 'right' }}>
                  {/* Skip Button */}
                  <button
                    onClick={skipWalkthrough}
                    style={{
                      padding: '6px 12px',
                      border: '1px solid #4a5568',
                      borderRadius: '4px',
                      background: 'transparent',
                      color: '#a0aec0',
                      cursor: 'pointer',
                      fontSize: '14px',
                      transition: 'all 0.2s',
                      marginRight: '15px'

                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#4a5568'
                      e.target.style.color = 'white'
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'transparent'
                      e.target.style.color = '#a0aec0'
                    }}
                  >
                    Skip
                  </button>
                  {currentStep > 0 && (
                    // <button onClick={() => setCurrentStep(currentStep - 1)} style={{ marginRight: 8 }}>
                    //   Back
                    // </button>
                    <button
                      onClick={() => setCurrentStep(currentStep - 1)}
                      style={{
                        marginRight: 12,
                        padding: '8px 16px',
                        backgroundColor: '#e0e0e0',
                        color: '#333',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '500',
                        transition: 'background-color 0.3s',
                      }}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = '#d5d5d5')}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = '#e0e0e0')}
                    >
                      Back
                    </button>
                  )}
                  <button
                    onClick={() => {
                      if (currentStep === walkthroughSteps.length - 1) {
                        setWalkthroughActive(false)
                        setCurrentStep(0)
                      } else {
                        setCurrentStep(currentStep + 1)
                      }
                    }
                    }
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#3b82f6',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontWeight: '500',
                      transition: 'background-color 0.3s',
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#2563eb')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#3b82f6')}
                  >
                    {currentStep === walkthroughSteps.length - 1 ? 'Finish' : 'Next'}
                  </button>
                </div>
              </div>
            </>
          )}


          <NotificationsIcon usertype={user.usertype} />
          {/* Walkthrough Button - Only show on desktop */}
          {/* {!matches && (
            <Button
              onClick={() => setWalkthroughActive(true)}
              style={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                backgroundColor: '#3b82f6',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '6px',
                zIndex: 2100
              }}
            >
              Start Walkthrough
            </Button>
          )} */}
          {/* Profile div */}
          <div
            ref={setWalkthroughRef('account-menu')}
            onClick={() => {
              setOpenMenu(true)
            }}
            style={{
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            aria-controls={openMenu ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={openMenu ? 'true' : undefined}
          >
            <Avatar
              sx={{
                width: '32px',
                height: '32px',
                marginRight: matches ? '0px' : '6px' // Adjust margin for small screens
              }}
            />

            {!matches && (
              <TextSemiBold
                style={{
                  fontSize: '15px',
                  textTransform: 'capitalize'
                }}
              >
                <TextHover>
                  {user?.firstname} {user?.lastname}
                </TextHover>
              </TextSemiBold>
            )}
          </div>

          <Menu
            id='account-menu'
            open={openMenu}
            onClose={handleMouseLeave}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  overflow: 'hidden',
                  filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
                  mt: matches ? 3 : 9.8,
                  borderRadius: '0px',
                  transform: 'translateY(16px) !important',
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                  },
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0
                  }
                }
              }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            {[
              {
                label: 'Edit Profile',
                icon: <img src={`${appassets.edit}`} alt='edit' />,
                nav: '/recruiter/editprofile'
              },
              {
                label: 'Update your phone number',
                icon: <img src={`${appassets.call}`} alt='edit' />,
                nav: '/recruiter/editprofile',
                state: 'phone'
              },
              {
                label: 'Edit Preferences',
                icon: (
                  <MarkEmailReadIcon
                    style={{ margin: -4, color: theme.palette.text.secondary }}
                  />
                ),
                nav: '/recruiter/editpreferences'
              },
              {
                label: 'Contact us',
                icon: <img src={appassets.help} alt='help' />,
                type: ENV.contact_us
              },
              {
                label: 'Change password',
                icon: (
                  <LockResetIcon
                    style={{ margin: -4, color: theme.palette.text.secondary }}
                  />
                ),
                nav: '/recruiter/changepassword'
              },
              {
                label: 'FAQ',
                icon: <QuizIcon fontSize='small' />,
                type: '/faq'
              },
              {
                label: 'Logout',
                icon: <img src={appassets.logout} alt='logout' />,
                type: 'logout'
              }
            ].map((item, index) => (
              <>
                {index === 0 && (
                  <Box
                    style={{
                      width: '100%',
                      height: '4px',
                      background: theme.palette.primary.main,
                      padding: '0px',
                      marginTop: '-7px'
                    }}
                  />
                )}
                <MenuItem
                  ref={item.label === 'Edit Profile' ? setWalkthroughRef('edit-profile') : null}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    handleMouseLeave()

                    if (item.type) {
                      if (item.type === 'logout') {
                        dispatch(logoutUser(navigate, true))
                      } else {
                        window.open(item.type, '__blank')
                      }
                    } else {
                      navigate(item.nav, { state: item.state })
                    }
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <TextSemiBold style={{ fontSize: '15px' }}>
                    <TextHover>{item.label}</TextHover>
                  </TextSemiBold>
                </MenuItem>
              </>
            ))}
          </Menu>
          {/* <Button
            onClick={() => setWalkthroughActive(true)}
            style={{
              position: 'fixed',
              bottom: 20,
              right: 20,
              backgroundColor: '#3b82f6',
              color: '#fff',
              padding: '10px 16px',
              borderRadius: '6px',
              zIndex: 2100
            }}
          >
            Start Walkthrough
          </Button> */}
        </div>
      </Toolbar>
    </AppBar>
  )
}
